import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { BsInstagram, BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs';
import { FaMapMarkerAlt } from "react-icons/fa";
import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Gallery.css';

const fadeIn = {
  hidden: { opacity: 0, y: 20, scale: 0.9 },
  visible: { opacity: 1, y: 0, scale: 1 }
};

const Gallery = () => {
  const scrollRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const galleryRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              setIsVisible(true);
            } else {
              setIsVisible(false);
            }
          });
        },
        { threshold: 0.1 }
    );

    if (galleryRef.current) {
      observer.observe(galleryRef.current);
    }

    return () => {
      if (galleryRef.current) {
        observer.unobserve(galleryRef.current);
      }
    };
  }, []);

  const smoothScroll = (element, target, duration) => {
    const start = element.scrollLeft;
    const change = target - start;
    const increment = 20;
    let currentTime = 0;

    const animateScroll = () => {
      currentTime += increment;
      const val = Math.easeInOutQuad(currentTime, start, change, duration);
      element.scrollLeft = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  };

  Math.easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  };

  const scroll = (direction) => {
    const { current } = scrollRef;
    const scrollAmount = 330;

    if (direction === 'left') {
      smoothScroll(current, current.scrollLeft - scrollAmount, 500);
    } else {
      smoothScroll(current, current.scrollLeft + scrollAmount, 500);
    }
  };

  return (
      <div className="app__gallery flex__center">
        <motion.div
            ref={galleryRef}
            className="app__gallery-content"
            initial="hidden"
            animate={isVisible ? "visible" : "hidden"}
            variants={fadeIn}
            transition={{ duration: 0.5, ease: 'easeInOut' }}
        >
          <SubHeading title="Une immersion chez Au Mirodélice" />
          <h1 className="headtext__cormorant">Photos</h1>
          <p className="p__opensans4" style={{ color: '#AAAAAA', marginTop: '2rem' }}>
            Parcourez notre restaurant à travers ces images. Découvrez notre intérieur et nos spécialités asiatiques. Chaque photo vous donne un avant-goût de ce qui vous attend.
          </p>
          <a href="https://www.google.fr/maps/place/Au+Mirod%C3%A9lice/@48.8735721,2.3159167,17z/data=!4m6!3m5!1s0x47e66f867d12760d:0xe4291d99abb41324!8m2!3d48.8735835!4d2.315987!16s%2Fg%2F11jh2zhlpd?authuser=1&entry=ttu" target="_blank" rel="noopener noreferrer">
            <button type="button" className="custom__button">En voir plus</button>
          </a>
        </motion.div>
        <div className="app__gallery-images">
          <div className="app__gallery-images_container" ref={scrollRef}>
            {[images.restau4, images.restau1, images.restau2, images.restau3, images.restau5].map((image, index) => (
                <motion.div
                    className="app__gallery-images_card flex__center"
                    key={`gallery_image-${index + 1}`}
                    initial="hidden"
                    animate={isVisible ? "visible" : "hidden"}
                    variants={fadeIn}
                    transition={{ duration: 0.5, ease: 'easeInOut' }}
                >
                  <a href="https://www.google.fr/maps/place/Au+Mirod%C3%A9lice/@48.8735721,2.3159167,17z/data=!4m6!3m5!1s0x47e66f867d12760d:0xe4291d99abb41324!8m2!3d48.8735835!4d2.315987!16s%2Fg%2F11jh2zhlpd?authuser=1&entry=ttu" target="_blank" rel="noopener noreferrer">
                    <img src={image} alt="gallery_image" />
                    <FaMapMarkerAlt className="gallery__image-icon" />
                  </a>
                </motion.div>
            ))}
          </div>
          <div className="app__gallery-images_arrows">
            <BsArrowLeftShort className="gallery__arrow-icon" onClick={() => scroll('left')} />
            <BsArrowRightShort className="gallery__arrow-icon" onClick={() => scroll('right')} />
          </div>
        </div>
      </div>
  );
};

export default Gallery;